module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": this.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_vm._v("\n        Реорганизации(" + _vm._s(_vm.items.length) + "):\n      ")]), _vm._v(" "), (this.items.length === 0) ? _c('v-flex', [_vm._v("\n        Данные не найдены.\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(reorg) {
    return [(reorg.restricted && reorg.restricted.code > 0) ? _c('div', [_vm._v("Доступ ограничен "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(reorg.restricted))
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(reorg.created, _vm.formats.formatDate)))]), _vm._v(" " + _vm._s(reorg.form) + "\n            ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isLoaded),
        expression: "isLoaded"
      }]
    }, [_vm._l((reorg.reorgees), function(item) {
      return [_c('v-flex', {
        attrs: {
          "pl-2": ""
        }
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderReference(item))
        }
      }), _vm._v(" "), _c('v-flex', {
        attrs: {
          "pl-2": ""
        }
      }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
        }
      })])]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(item))
        }
      }), _vm._v("\n                      " + _vm._s(item.nextState) + "\n                    ")])], 1)]
    })], 2)]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-906157e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/ReorgPanel.vue
// module id = 1071
// module chunks = 1